//C:\Users\billy\billych\billychristi.com\src\Pages\Projects

import React from "react";
import banner from "../../assets/projects/customeranalysisbanner.png";
import ss1 from "../../assets/screenshots/customerfeedbackanalysis/ss1.png"
import ss2 from "../../assets/screenshots/customerfeedbackanalysis/ss1.png"
import ss3 from "../../assets/screenshots/customerfeedbackanalysis/ss1.png"
import ss4 from "../../assets/screenshots/customerfeedbackanalysis/ss1.png"
import ss5 from "../../assets/screenshots/customerfeedbackanalysis/ss1.png"

const CustomerFeedbackAnalysisPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">

  {/* Banner Image */}
  <section className="w-full">
    <img
      src={banner}
      alt="Customer Feedback AI Analysis System Banner"
      className="w-[500px] rounded-xl shadow-md object-cover"
    />
  </section>

  {/* Project Title & Overview */}
  <section>
    <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
      Customer Feedback AI Analysis System
    </h1>
    <p className="text-lg text-content lg:max-w-4xl">
      The Customer Feedback AI Analysis System is an AI-powered automation workflow that helps businesses automatically collect, analyze, and act on customer feedback. Built using n8n, Airtable, Jotform, Slack, and OpenAI, this system captures feedback submitted through a Jotform form, stores the data in Airtable, and analyzes the feedback using an AI LLM chain. The AI generates sentiment analysis and insights from the feedback, which are then stored in Airtable. Based on the AI sentiment result, the system automatically sends notifications through email and Slack to ensure the appropriate teams are alerted. Negative feedback is escalated to an urgent Slack channel and operational team, while positive feedback is shared in a dedicated positive feedback Slack channel. This allows teams to quickly respond to customer issues and use feedback to improve their products and services.
    </p>
  </section>

  {/* Live Demo */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      ▶️ Live Demo
    </h2>
    <div className="w-full aspect-video">
      <iframe
        className="w-full h-full rounded-lg shadow"
        src="https://www.youtube.com/embed/l8XI_fTD-Ic"
        title="Customer Feedback AI Analysis System Demo"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </section>

  {/* Technology Stack */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      💻 Technology Stack
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li><strong>n8n:</strong> Core automation engine that orchestrates the entire workflow</li>
      <li><strong>Jotform:</strong> Customer feedback collection form that triggers the automation</li>
      <li><strong>Airtable:</strong> Stores customer feedback data and generated AI analysis results</li>
      <li><strong>OpenAI (ChatGPT):</strong> Performs AI analysis on customer feedback using an LLM chain</li>
      <li><strong>Email Integration:</strong> Sends feedback summaries and AI analysis to customers and operational teams</li>
      <li><strong>Slack Integration:</strong> Sends notifications to internal Slack channels based on sentiment</li>
    </ul>
  </section>

  {/* AI Automation Features */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      🤖 AI Automation Features (n8n)
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>Automatically receives customer feedback submissions from Jotform</li>
      <li>Stores all feedback data inside Airtable for centralized tracking</li>
      <li>AI LLM Chain analyzes feedback content and generates insights</li>
      <li>Performs sentiment analysis to classify feedback as positive or negative</li>
      <li>Stores AI-generated analysis results inside Airtable for future review</li>
    </ul>
  </section>

  {/* Notification & Decision Support */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      📩 Automated Notifications & Decision Support
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>If AI detects <strong>negative sentiment</strong>, the system sends an email to the customer and operational team</li>
      <li>Negative feedback is also sent to the <strong>urgent Slack channel</strong> for immediate attention</li>
      <li>If AI detects <strong>positive sentiment</strong>, the system sends an email to the customer and operational team</li>
      <li>Positive feedback is shared in a <strong>positive feedback Slack channel</strong></li>
      <li>All notifications include the original customer feedback and the AI-generated analysis</li>
      <li>This system helps teams quickly identify issues and respond to customer needs</li>
    </ul>
  </section>

  {/* Workflow Overview */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      🔄 Full Workflow Overview
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>User submits feedback using the Jotform customer feedback form</li>
      <li>Jotform triggers the n8n automation workflow</li>
      <li>Customer feedback is stored in Airtable</li>
      <li>An AI LLM chain analyzes the feedback content</li>
      <li>The AI-generated analysis result is stored in Airtable</li>
      <li>The system determines the feedback sentiment (positive or negative)</li>
      <li>Email notifications are sent to the customer and operational team</li>
      <li>Slack notifications are sent to the appropriate Slack channel based on sentiment</li>
    </ul>
  </section>

  


  {/* Screenshots */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      🖼️ Project Images & Screenshots
    </h2>

    <div className="flex flex-col gap-6">
    <div>
        <p className="mb-2 font-medium">Key Features</p>
        <a href={banner} target="_blank" rel="noopener noreferrer">
          <img src={banner} alt="Customer Feedback Workflow" className="w-full rounded-lg shadow" />
        </a>
      </div>
      <div>
        <p className="mb-2 font-medium">Customer Feedback AI Analysis Workflow (n8n)</p>
        <a href={ss1} target="_blank" rel="noopener noreferrer">
          <img src={ss1} alt="Customer Feedback Workflow" className="w-full rounded-lg shadow" />
        </a>
      </div>

   
<div>
  <p className="mb-2 font-medium">Email Notification for Positive Feedback Sentiment</p>
  <a href={ss2} target="_blank" rel="noopener noreferrer">
    <img src={ss2} alt="Email Notification Positive Sentiment" className="w-full rounded-lg shadow" />
  </a>
</div>

<div>
  <p className="mb-2 font-medium">Slack Notification for Positive Feedback Sentiment</p>
  <a href={ss4} target="_blank" rel="noopener noreferrer">
    <img src={ss4} alt="Slack Notification Positive Sentiment" className="w-full rounded-lg shadow" />
  </a>
</div>

<div>
  <p className="mb-2 font-medium">Email Notification for Negative Feedback Sentiment</p>
  <a href={ss3} target="_blank" rel="noopener noreferrer">
    <img src={ss3} alt="Email Notification Negative Sentiment" className="w-full rounded-lg shadow" />
  </a>
</div>



<div>
  <p className="mb-2 font-medium">Slack Notification for Negative Feedback Sentiment</p>
  <a href={ss5} target="_blank" rel="noopener noreferrer">
    <img src={ss5} alt="Slack Notification Negative Sentiment" className="w-full rounded-lg shadow" />
  </a>
</div>


    </div>

  </section>

</main>
);

export default CustomerFeedbackAnalysisPage;
